<template>
    <div class="questionBox">
        <img @click="showMsg = !showMsg" class="questionSvg" :src="this[iconColor]" alt="">
        <p v-if="showMsg" class="questionMsg" :class="{ w240: isWebPositive }">
            <span v-html="msg"></span>
            <span class="triangle-up"></span>
        </p>
    </div>
</template>

<script>
const questionIcon = require("../../assets/img/icon/question.svg")
const questionIconB0 = require("../../assets/img/icon/question_B0.svg")

export default {
    name: "QuestionBox",
    props: {
        msg: {
            type: String,
            default: '舆情健康指数：实时计算近24h内数据的舆情健康指数'
        },
        iconColor: {
            type: String,
            default: 'questionIcon'
        },
        isWebPositive: Boolean,
    },
    data() {
        return {
            showMsg: false,
            questionIcon: questionIcon,
            questionIconB0: questionIconB0
        }
    },
    mounted() {
        // this.renderIcon = this[this.iconColor]
        document.addEventListener("click", (e)=>{
            if(!(e.target && e.target._prevClass == "questionSvg") )
                this.showMsg = false;
        })
    }
}
</script>

<style lang="scss" scoped>
.questionBox {
    position: relative;
    text-indent: 0;
    .questionSvg {
        width: 16px;
        height: 16px;
        vertical-align: middle;
    }
    .questionMsg {
        width: 200px;
        padding: 5px;
        font-size: 12px;
        line-height: 16px;
        position: absolute;
        top: 35px;
        left: -60px;
        background-color: rgba(31, 63, 119, 0.8);
        z-index: 10;
        border-radius: 4px;
        font-weight: 300;
    }
    .triangle-up {
        display: inline-block;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 12px solid rgba(31, 63, 119, 0.8);
        position: absolute;
        top: -12px;
        left: 60px;
    }
    .w240 {
        width: 240px;
    }
}
</style>